
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/facts/ristorante",
      function () {
        return require("private-next-pages/facts/ristorante/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/facts/ristorante"])
      });
    }
  